"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSlugFromString = createSlugFromString;
exports.formatPropertyPageURL = formatPropertyPageURL;
const html_entities_1 = require("html-entities");
const stripSpecialChars = (word) => word.replace(/[^a-zA-Z0-9-]/gm, '');
function createSlugFromString(name, code) {
    const sanitizedName = (0, html_entities_1.decode)(name)
        .split(' ')
        .map((word) => stripSpecialChars(word))
        .filter((word) => word !== '-' && word.length)
        .join('-');
    return `${sanitizedName}-${code}`.toLowerCase();
}
function formatPropertyPageURL(product, name, code, queryString, siteName, siteCode) {
    const queryParams = queryString ? `?${queryString}` : '';
    return `/${product}${siteName && siteCode ? `/${createSlugFromString(siteName, siteCode)}` : ''}/${createSlugFromString(name, code)}${queryParams}`;
}
//# sourceMappingURL=pdp-url.js.map